var EcommerceCartDataSourceEnum;
(function (EcommerceCartDataSourceEnum) {
    EcommerceCartDataSourceEnum["default"] = "default";
    EcommerceCartDataSourceEnum["disabled"] = "disabled";
    EcommerceCartDataSourceEnum["iows"] = "IOWS";
    EcommerceCartDataSourceEnum["cartApi"] = "CartApi";
    EcommerceCartDataSourceEnum["chinaCartApi"] = "ChinaCartApi";
    EcommerceCartDataSourceEnum["nifApi"] = "NifApi";
    EcommerceCartDataSourceEnum["mvecom"] = "MvEcom";
    EcommerceCartDataSourceEnum["mvecomV2"] = "MvEcomV2";
    EcommerceCartDataSourceEnum["iksa"] = "IKSA";
})(EcommerceCartDataSourceEnum || (EcommerceCartDataSourceEnum = {}));
export default EcommerceCartDataSourceEnum;
//# sourceMappingURL=EcommerceCartDataSourceEnum.js.map